import useFetch from '../../../hooks/useFetch';
import { ServiceEvents } from '../shared/interfaces';
import { useState } from 'react';
import { EndPoints } from '../EndPoints';
import {
    PaymentCondition,
    PaymentConditionFilters,
    PaymentConditionDataForm
} from '../../models/PaymentCondition';

const usePaymentConditionService = () => {
    const { doGet, doPost, doPut, doDelete } = useFetch();

    const [fetchingGetPaymentConditions, setFetchingGetPaymentConditions] = useState(false);
    const [fetchingStorePaymentCondition, setFetchingStorePaymentCondition] = useState(false);
    const [fetchingEditPaymentCondition, setFetchingEditPaymentCondition] = useState(false);
    const [fetchingUpdatePaymentCondition, setFetchingUpdatePaymentCondition] = useState(false);
    const [fetchingDeletePaymentCondition, setFetchingDeletePaymentCondition] = useState(false);
    const [fetchingActivePaymentCondition, setFetchingActivePaymentCondition] = useState(false);

    const getPaymentConditions = (
        filters: PaymentConditionFilters,
        events: ServiceEvents = {}
    ) => {
        const queryString = Object.entries(filters)
            .filter(([, value]) => value !== undefined && value !== '' && value !== null)
            .map(([key, value]) => `${key}=${value}`)
            .join('&');

        const url = `${EndPoints.PAYMENT_CONDITIONS.GET_PAYMENT_CONDITIONS}?${queryString}`;
        doGet({
            ...events,
            url: url,
            setFetching: setFetchingGetPaymentConditions
        });
    };

    const storePaymentCondition = (
        paymentCondition: PaymentConditionDataForm,
        events: ServiceEvents = {}
    ) => {
        doPost({
            ...events,
            url: EndPoints.PAYMENT_CONDITIONS.STORE_PAYMENT_CONDITION,
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            requestType: 'json',
            body: paymentCondition,
            setFetching: setFetchingStorePaymentCondition
        });
    };

    const editPaymentCondition = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.PAYMENT_CONDITIONS.EDIT_PAYMENT_CONDITION.replace(':id', id.toString()),
            setFetching: setFetchingEditPaymentCondition
        });
    };

    const updatePaymentCondition = (
        id: number,
        paymentCondition: PaymentConditionDataForm,
        events: ServiceEvents = {}
    ) => {
        doPut({
            ...events,
            url: EndPoints.PAYMENT_CONDITIONS.UPDATE_PAYMENT_CONDITION.replace(':id', id.toString()),
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            requestType: 'json',
            body: paymentCondition,
            setFetching: setFetchingUpdatePaymentCondition
        });
    };

    const deletePaymentCondition = (id: number, events: ServiceEvents = {}) => {
        doDelete({
            ...events,
            url: EndPoints.PAYMENT_CONDITIONS.DELETE_PAYMENT_CONDITION.replace(':id', id.toString()),
            setFetching: setFetchingDeletePaymentCondition
        });
    };

    const activePaymentCondition = (
        id: number,
        active: boolean,
        events: ServiceEvents = {}
    ) => {
        doPost({
            ...events,
            url: EndPoints.PAYMENT_CONDITIONS.ACTIVE_PAYMENT_CONDITION.replace(':id', id.toString()),
            body: { active: active },
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            requestType: 'json',
            setFetching: setFetchingActivePaymentCondition
        });
    };

    return {
        fetchingGetPaymentConditions,
        fetchingStorePaymentCondition,
        fetchingEditPaymentCondition,
        fetchingUpdatePaymentCondition,
        fetchingDeletePaymentCondition,
        fetchingActivePaymentCondition,
        getPaymentConditions,
        storePaymentCondition,
        editPaymentCondition,
        updatePaymentCondition,
        deletePaymentCondition,
        activePaymentCondition
    };
};

export default usePaymentConditionService;
